import { useCallback } from "react";
import { useSdkContext } from "scmp-sdk/components/contexts";

import type { Props } from ".";

export const useBookmarkButton = () => {
  const { bookmark } = useSdkContext();

  const checkIsBookmarked = useCallback(
    ({ entityId }: { entityId: string }) => bookmark.check({ entityId }),
    [bookmark],
  );

  type Payload = Omit<Parameters<typeof bookmark.update>[0], "action">;
  const bindBookmarkButton = useCallback(
    ({ entityId, trackings }: Payload, onClick?: () => void) => {
      const isBookmarked = checkIsBookmarked({ entityId });
      const props: Props = {
        isBookmarked,
        onClick: action => {
          bookmark.update({ action, entityId, trackings });
          onClick?.();
        },
      };
      return props;
    },
    [bookmark, checkIsBookmarked],
  );

  return { bindBookmarkButton, checkIsBookmarked };
};
